<template>
    <SetAmazonAssumeRoleCredentialsDialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAwsAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAwsAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </SetAmazonAssumeRoleCredentialsDialog>
</template>

<script>
import SetAmazonAssumeRoleCredentialsDialog from '@/components/Settings.CloudAccounts/Amazon/SetAmazonAssumeRoleCredentialsDialog.vue';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
import { useTenantStore } from '@/stores';
import { mapStores } from 'pinia';

export default {
    components: { SetAmazonAssumeRoleCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
    computed: {
        ...mapStores(useTenantStore)
    }
};
</script>
